export class PosLeaderboardCardDetail {
  scope = "";
  rankTitle = "";
  rank = 0;
  rankDelta = 0;
  rewardLimit = 0;
  mode = "";
  estimatedReward = 0;
  nextRevenue = 0;
  nextReward = 0;

  constructor(fields?: Partial<PosLeaderboardCardDetail>) {
    Object.assign(this, fields);
  }
}

export class Cursor {
  next: null | number = null;
  previous: null | number = null;

  constructor(fields?: Partial<Cursor>) {
    Object.assign(this, fields);
  }
}

export class Meta {
  period = "";
  scope = "";
  mode = "";
  lastSyncAt = "";
  cursor = new Cursor();

  constructor(fields?: Partial<Meta>) {
    Object.assign(this, fields);
  }
}

export class HistoryRank {
  rank = 0;
  count = 0;

  constructor(fields?: Partial<HistoryRank>) {
    Object.assign(this, fields);
  }
}

export class Leaderboard {
  rank = 0;
  rankDelta = 0;
  name = "";
  posCode = "";
  cityCode = "";
  revenue: null | number = null;
  reward = 0;
  tier = 0;
  isCurrentPos = false;
  historyRank: HistoryRank[] = [];

  constructor(fields?: Partial<Leaderboard>) {
    Object.assign(this, fields);
  }
}

export class PosLeaderboardCard {
  national = new PosLeaderboardCardDetail();
  newPos = new PosLeaderboardCardDetail();
  area = new PosLeaderboardCardDetail();

  constructor(fields?: Partial<PosLeaderboardCard>) {
    Object.assign(this, fields);

    if (!fields?.national) {
      this.national = new PosLeaderboardCardDetail();
    }

    if (!fields?.newPos) {
      this.newPos = new PosLeaderboardCardDetail();
    }

    if (!fields?.area) {
      this.area = new PosLeaderboardCardDetail();
    }
  }
}

export class PosLeaderboardTotal {
  totalEstimatedReward = 0;
  totalRevenue = 0;

  constructor(fields?: Partial<PosLeaderboardTotal>) {
    Object.assign(this, fields);
  }
}

export class PosLeaderboardList {
  meta = new Meta();
  leaderboard: Leaderboard[] = [];

  constructor(fields?: Partial<PosLeaderboardList>) {
    Object.assign(this, fields);
  }
}

export class PosLeaderboard {
  period = "";
  lastUpdatedAt = "";
  cards = new PosLeaderboardCard();
  totals = new PosLeaderboardTotal();
  isNoData = false;

  constructor(fields?: Partial<PosLeaderboard>) {
    Object.assign(this, fields);
  }
}

export class Tier {
  areaCode = "";
  configId = 0;
  rewardTier = 0;
  rankStart = 0;
  rankEnd = 0;

  constructor(fields?: Partial<Tier>) {
    Object.assign(this, fields);
  }
}

export class PosLeaderboardCofig {
  scope = "";
  areaCode = "";
  tier: Tier[] = [];

  constructor(fields?: Partial<PosLeaderboardCofig>) {
    Object.assign(this, fields);
  }
}

